import api from "./api/client";

function unwrapData(response) {
  return response?.data?.data ?? response?.data ?? null;
}

function uniqueIds(ids = []) {
  return Array.from(
    new Set((ids || []).map((id) => String(id || "").trim()).filter(Boolean)),
  );
}

const vehicleService = {
  create(payload) {
    return api.post("/v1/vehicle", payload);
  },

  getAll(params = {}) {
    return api.get("/v1/vehicle", { params });
  },

  getById(id) {
    return api.get(`/v1/vehicle/${id}`);
  },

  async getByDriverUid(driverUid) {
    if (!driverUid) return null;
    const response = await api.get(`/v1/vehicle/by-driver/${driverUid}`);
    return unwrapData(response);
  },

  async getByIds(ids = []) {
    const unique = uniqueIds(ids);
    if (unique.length === 0) return [];
    const response = await api.get("/v1/vehicle/by-ids", {
      params: { ids: unique.join(",") },
    });
    const data = unwrapData(response);
    return Array.isArray(data) ? data : [];
  },

  async getByDriverUids(driverUids = []) {
    const unique = uniqueIds(driverUids);
    if (unique.length === 0) return {};
    const response = await api.post("/v1/vehicle/by-driver-uids", {
      driverUids: unique,
    });
    const data = unwrapData(response);
    return data && typeof data === "object" ? data : {};
  },

  update(id, payload) {
    const vehicleId = String(id || "").trim();
    if (!vehicleId || vehicleId === "undefined") {
      return this.create(payload);
    }
    return api.put(`/v1/vehicle/${vehicleId}`, payload);
  },

  delete(id) {
    return api.delete(`/v1/vehicle/${id}`);
  },
};

export default vehicleService;
